// Martin tile-server source for active NGFS detection polygons (see the
// heat_detection_polygons_active view + martin config in watchduty-backend).
// Both the tile URL path and the vector source-layer use this name.
export const SOURCE_LAYER = 'heat_detection_polygons';
export const SOURCE_ID = 'ngfs-detections';
export const LINE_LAYER_ID = 'ngfs-detections-line';

export const FILL_LAYER_ID = 'ngfs-detections-fill';
export const SELECTED_FILL_LAYER_ID = 'ngfs-detections-selected-fill';
export const SELECTED_STROKE_LAYER_ID = 'ngfs-detections-selected-stroke';

// Active NGFS detections drop off the map in real time — the backend view only
// surfaces the last 30 minutes — so refresh the tiles on the same cadence as
// the heat-detections layer to keep the displayed set current.
export const REFRESH_INTERVAL_SECONDS = 60;

// Fire Radiative Power (megawatts) → fill color, matching the NGFS portal's
// intensity bands: yellow (very low) → amber → orange → red → magenta
// (extreme). The scale is log-spaced; frp is clamped to >= 0 before
// interpolation and values above the top breakpoint stay magenta.
export const FRP_COLOR_STOPS: ReadonlyArray<readonly [number, string]> = [
  [0, '#FFEA3D'],
  [1, '#EBB60F'],
  [10, '#EE682F'],
  [100, '#EF3445'],
  [1000, '#981671'],
];
